import React from 'react';
import PropTypes from 'prop-types';
import { Image, mergeClasses } from '@fluentui/react-components';

import { LinkedInAudienceCompanySizeMap } from '../consts';
import { getCompanyNameOptionStyles } from '../styles/company-name-option-styles';

export const CompanyNameOption = ({
  name, logo, industry, size,
}) => {
  const classes = getCompanyNameOptionStyles();

  return (
    <div className="company-name-option">
      <div className={classes.nameContainer}>
        {logo && <Image className={classes.logo} src={logo} aria-hidden />}
        <div className={mergeClasses('company-name', classes.name)}>
          {name}
        </div>
      </div>
      <div className={mergeClasses('industry-and-size', classes.industryAndSize)}>
        {industry}; {LinkedInAudienceCompanySizeMap[size]}
      </div>
    </div>
  );
};

CompanyNameOption.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  industry: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
};
